import { ProgramArticle } from "./../../models/program-article";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ProgramArticleTranslation,
  Destination,
} from "../../models/program-article-translation";
import { Router } from "@angular/router";
import { Value } from "../../models/value";
import * as _ from "lodash";
import {
  ProgramArticleTranslationETTValue,
  ProgramArticlePictureETTValue,
} from "../../models/program-article-translation-value";
import { ScheduleService } from "../../services/schedule.service";
import { ActionService } from "../../services/action.service";
import { MdDialog } from "@angular/material";
import { SuccessComponent } from "../../modals/success/success.component";
import { Schedule } from "../../models/schedule";
import { User } from "../../models/user";
import { Language } from "../../models/language";
import { Channel } from "../../models/channel";
import { ProgramArticlesActions } from "../../store/actions/program-articles.actions";

@Component({
  selector: "app-program-article-form",
  templateUrl: "./program-article-form.component.html",
  styleUrls: ["./program-article-form.component.scss"],
})
export class ProgramArticleFormComponent implements OnInit {
  @Input() destination: Destination;
  @Input() translation: ProgramArticleTranslation;
  @Input() pictureOnly: boolean;
  @Input() editMode: boolean;
  @Input() programArticle: ProgramArticle;
  @Input() currentUser: User;
  @Output() saveProgramOnly = new EventEmitter();
  @Output() saveProgramAndReplays = new EventEmitter();
  @Output() seeReplays = new EventEmitter();
  @Output() seeMultiCams = new EventEmitter();
  @Output() seeAdditionalPictures = new EventEmitter();
  @Output() duplicateData = new EventEmitter();
  @Output() duplicateDigitalDataToPartners = new EventEmitter();
  @Output() initialData = new EventEmitter();
  @Output() initialPartnersData = new EventEmitter();
  @Output() duplicateInter = new EventEmitter<any>();
  @Output() duplicatePressInter = new EventEmitter<any>();
  @Output() duplicatePartners = new EventEmitter<any>();
  @Output() deleteDataInter = new EventEmitter<any>();

  initialTranslations: ProgramArticleTranslationETTValue[];
  initialPictures: ProgramArticlePictureETTValue[];
  programModified: boolean;

  canDuplicate: boolean;
  canDuplicateToInter: boolean;
  canDuplicateToPartners: boolean;

  dataDuplicationOnCurrentLanguage: boolean;

  isDuplicateToPressOn: boolean;
  isDuplicateToInterOn: boolean;
  isDuplicateToPartnersOn: boolean;
  disablePressField: boolean;
  disablePartnersField: boolean;

  isProgramModifiedBeforeDuplicated: boolean;
  canScheduleMagicBox: boolean;

  multilingualLanguages: Language[];
  availableLanguages: Language[];
  selectAllMultilanguage: Language;
  formats: any[] = ["16:9", "4:3", "3:4"];
  beamPictureFormats: boolean;

  constructor(
    private router: Router,
    private scheduleService: ScheduleService,
    private actionService: ActionService,
    private programArticlesActions: ProgramArticlesActions,
    private mdDialog: MdDialog
  ) {
    this.initialTranslations = [];
    this.initialPictures = [];
    this.multilingualLanguages = [];
    this.availableLanguages = [];
    this.selectAllMultilanguage = new Language({ id: -1 });
    this.programModified = false;
    this.isProgramModifiedBeforeDuplicated = false;
    this.beamPictureFormats = false;
  }

  /**
   * Get the translation and clone it to avoid memory link edition
   */
  ngOnInit() {
    this.canScheduleMagicBox = this.programArticle.magicBoxScheduleAvailable;
    this.initialTranslations = _.cloneDeep(this.destination.value.translations);
    this.initialPictures = _.cloneDeep(this.destination.value.pictures);

    setInterval(() => {
      Object.keys(this.destination.value.translations).forEach((item) => {
        if (
          (this.destination.value.translations[item] &&
            this.initialTranslations[item] &&
            this.destination.value.translations[item].content &&
            (this.destination.value.translations[item].content !==
              this.initialTranslations[item].content ||
              this.destination.value.translations[item].isLocked !==
                this.initialTranslations[item].isLocked)) ||
          (this.destination.value.translations[item] &&
            this.destination.value.translations[item].modified) ||
          this.destination.modified
        ) {
          this.programModified = true;
        }
      });
    }, 200);

    this.multilingualLanguages.push(this.currentUser.currentLanguage);
    this.availableLanguages = this.currentUser.languages.filter((item) =>
      this.programArticle.availableLanguages.includes(item.id)
    );

    // Check list of languages set in admin menu data duplication language
    this.actionService.getDataDuplicateLanguage().subscribe((result) => {
      var currentLanguageAvailable = result.filter(
        (x) => x.languageId === this.currentUser.currentLanguage.id
      );

      this.availableLanguages = this.availableLanguages.filter((x) =>
        currentLanguageAvailable
          .map((y) => y.broadcastCountry)
          .includes(x.value)
      );

      if (this.availableLanguages.length > 0) {
        this.dataDuplicationOnCurrentLanguage = true;
      } else {
        this.dataDuplicationOnCurrentLanguage = false;
      }

      this.multilingualLanguages.push({
        id: -1,
        isDefault: false,
        value: "",
        isoCode: "",
        timeZone: "",
        features: [],
        nameAndTimeZone: "",
      });
      this.clickOnSelectAllMultilingual();
    });

    this.canDuplicate =
      this.currentUser.currentLanguage.features.includes("DATA_DUPLICATE");

    this.canDuplicateToPartners =
      this.currentUser.currentLanguage.features.includes(
        "DATA_DUPLICATE_PARTNERS"
      );

    this.beamPictureFormats =
      this.currentUser.currentLanguage.features.includes(
        "BEAM_PICTURE_FORMATS"
      );

    if (this.beamPictureFormats)
      this.formats.push("140:303", "10:3", "1:1", "2:3", "485:173");

    // Check if current language have the duplicate inter activated, and check also if the current channel have INTER available
    this.canDuplicateToInter =
      this.currentUser.currentLanguage.features.includes(
        "DATA_DUPLICATE_INTER"
      ) &&
      this.availableLanguages.findIndex(
        (language) => language.value === "INTERNATIONAL"
      ) !== -1;

    this.disablePressField = false;
    this.disablePartnersField = false;

    // Apply the duplication
    if (this.canDuplicate) {
      if (this.destination.id === "Digital") {
        localStorage.setItem(
          "digitalDescriptionContent",
          this.destination.value.translations.find(
            (t) => t.fieldName === "Description"
          ).content
        );
      }
      this.duplicateDataPress({ checked: true });
    }

    if (this.canDuplicateToInter) {
      this.duplicateDataInter({ checked: true });
    }

    if (this.canDuplicateToPartners) {
      if (this.destination.id === "Digital") {
        localStorage.setItem(
          "digitalDescriptionContent",
          this.destination.value.translations.find(
            (t) => t.fieldName === "Description"
          ).content
        );
      }
      localStorage.setItem("isPartnersDuplicate", "true");
      this.duplicateDataPartners({ checked: true });
    } else {
      localStorage.setItem("isPartnersDuplicate", "false");
    }

    if (this.destination.id === "Partners") {
      setInterval(() => {
        if (localStorage.getItem("isPartnersDuplicate") === "true") {
          this.disablePartnersField = true;
          this.isDuplicateToPartnersOn = true;
        } else {
          this.disablePartnersField = false;
          this.isDuplicateToPartnersOn = false;
        }
      }, 200);
    }

    if (this.destination.id === "Press") {
      setInterval(() => {
        if (localStorage.getItem("isPressDuplicate") === "true") {
          this.disablePressField = true;
          this.isDuplicateToPressOn = true;
        } else {
          this.disablePressField = false;
          this.isDuplicateToPressOn = false;
        }
      }, 200);
    }
  }

  /**
   * Open the picture edition modal
   * ETT : navigate by ProgramExternalId, ChannelId and LanguageId
   * @param {string} type
   */
  editPicture(type: string, destination: string) {
    this.router.navigate(
      [
        {
          outlets: {
            modal: ["edit", "picture", type, destination, "program-article"],
          },
        },
      ],
      {
        queryParams: {
          format: this.formats,
        },
      }
    );
  }

  /**
   * Lock the field if the value change
   * @param {Value} value
   */
  changeValue(value: Value) {
    value.isLocked = true;

    if (localStorage.getItem("isPartnersDuplicate") === "true") {
      if (
        this.destination.id === "Partners" ||
        this.destination.id === "Digital"
      ) {
        this.duplicateDataPartners({ checked: true });
      }
    }

    if (this.destination.id === "Digital" && this.isDuplicateToPressOn) {
      this.duplicateDataPress({ checked: true });
    }

    if (this.isDuplicateToInterOn) {
      this.duplicateDataInter({ checked: true });
    }

    if (
      this.destination.id === "Digital" &&
      this.isDuplicateToPressOn &&
      this.isDuplicateToInterOn
    ) {
      this.duplicateDataPressInter();
    }
  }

  /**
   * Listen TinyMCE value changes and update the value for Press and Digital (No carriage return)
   * @param event
   * @param value
   */
  tinyMceChanged(event, destination: string, value: Value) {

    const unescapeHtml = (content: string): string => {
      return content
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    };

    if (destination !== "Digital" && destination !== "Press") {
      value.content = event;
    } else {
      value.content = event.replace(/<[^>]*>|\n/g, "");
    }

    if (
      destination === "Digital" &&
      (this.isDuplicateToPressOn || this.isDuplicateToPartnersOn)
    ) {
      localStorage.setItem("digitalDescriptionContent", value.content);
    }
    value.content = unescapeHtml(value.content);
    this.changeValue(value);
  }

  /**
   * Emit the save event
   */
  saveFieldsAction(saveReplays: boolean) {
    // Apply changes to all languages selected
    console.log("saveFieldsAction");
    if (
      this.multilingualLanguages.filter(
        (ml) => ml.id != this.currentUser.currentLanguage.id
      ).length > 0
    ) {
      console.log("saveFieldsAction -> pictureModified");
      this.programArticle.pictureModified = true;
      if (this.dataDuplicationOnCurrentLanguage == true) {
        console.log("saveFieldsAction -> dataDuplicationOnCurrentLanguage");
        console.log(
          "this.programArticle.destinations",
          this.programArticle.destinations
        );
        this.multilingualLanguages
          .filter(
            (ml) => ml.id != this.currentUser.currentLanguage.id && ml.id != -1
          )
          .forEach((multilingualLanguage) => {
            this.duplicateTitleToLanguage(multilingualLanguage);
            this.duplicateFeatureToLanguage(multilingualLanguage);
            this.duplicateDescriptionToLanguage(multilingualLanguage);
            this.duplicatePictureToLanguage(multilingualLanguage);
          });
        console.log(
          "apres this.programArticle.destinations",
          this.programArticle.destinations
        );
      }
    }

    // Reapply duplicate to be sure
    if (this.canDuplicate && this.isDuplicateToPressOn) {
      console.log("saveFieldsAction -> duplicateDataPress");
      this.duplicateDataPress({ checked: false });
      this.duplicateDataPress({ checked: true });
    }

    if (this.canDuplicateToInter && this.isDuplicateToInterOn) {
      console.log("saveFieldsAction -> duplicateDataInter");
      this.duplicateDataInter({ checked: false });
      this.duplicateDataInter({ checked: true });
    }

    if (
      this.canDuplicate &&
      this.canDuplicateToInter &&
      this.isDuplicateToPressOn &&
      this.isDuplicateToInterOn
    ) {
      console.log("saveFieldsAction -> duplicateDataPressInter");
      this.duplicateDataPressInter();
    }

    if (!saveReplays) {
      console.log("saveFieldsAction -> saveProgramOnly");
      this.saveProgramOnly.emit();
    } else {
      console.log("saveFieldsAction -> saveProgramAndReplays");
      this.saveProgramAndReplays.emit();
    }
  }

  duplicateTitleToLanguage(language: Language) {
    // Get the title
    let destinationName = this.destination.id;

    let title = _.cloneDeep(
      this.programArticle.destinations
        .find((t) => t.id === destinationName)
        .value.translations.find(
          (t) =>
            t.name === "Title" &&
            t.language.id === this.currentUser.currentLanguage.id
        )
    );

    title.language = language;
    title.programFieldId = 0;

    this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.push(title);
  }

  duplicateFeatureToLanguage(language: Language) {
    // Get the feature
    let destinationName = this.destination.id;

    let feature = _.cloneDeep(
      this.programArticle.destinations
        .find((t) => t.id === destinationName)
        .value.translations.find(
          (t) =>
            t.name === "Feature" &&
            t.language.id === this.currentUser.currentLanguage.id
        )
    );

    feature.language = language;
    feature.programFieldId = 0;

    this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.push(feature);
  }

  duplicateDescriptionToLanguage(language: Language) {
    // Get the description
    let destinationName = this.destination.id;

    let description = _.cloneDeep(
      this.programArticle.destinations
        .find((t) => t.id === destinationName)
        .value.translations.find(
          (t) =>
            t.name === "Description" &&
            t.language.id === this.currentUser.currentLanguage.id
        )
    );

    description.language = language;
    description.programFieldId = 0;

    this.programArticle.destinations
      .find((t) => t.id === destinationName)
      .value.translations.push(description);
  }

  duplicatePictureToLanguage(language: Language) {
    let destinationName = this.destination.id;

    var newPictures = _.cloneDeep(
      this.programArticle.destinations.find((d) => d.id === this.destination.id)
        .value.pictures
    );
    newPictures.map((x) => (x.language = language));

    this.programArticlesActions.setMultilingualPictures(
      newPictures,
      destinationName
    );
  }

  /**
   * Get all translations in all languages available
   */
  multilingual() {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "edit",
            "multilingual",
            this.programArticle.valEmiId,
            this.destination.id,
            this.programArticle.channel.id,
          ],
        },
      },
    ]);
  }

  seeReplaysEmitter() {
    this.seeReplays.emit();
  }

  seeMultiCamsEmitter() {
    this.seeMultiCams.emit();
  }

  additionalPicturesEmitter() {
    this.seeAdditionalPictures.emit();
  }

  scheduleMagicbox() {
    var schedule = new Schedule({
      language: [],
      channel: this.programArticle.channel,
      startDate: this.programArticle.broadcastDate,
      endDate: this.programArticle.broadcastDate,
      email: this.currentUser.isFromActiveDirectory
        ? this.currentUser.email
        : null,
    });
    schedule.channels.push(
      new Channel({
        id: this.programArticle.channel.id,
        name: this.programArticle.channel.name,
      })
    );
    schedule.languages.push(this.currentUser.currentLanguage);
    this.scheduleService.saveSchedule(schedule).subscribe(() => {
      this.mdDialog.closeAll();
      this.mdDialog.open(SuccessComponent, {
        data: { message: "Schedule has been created" },
      });
      this.canScheduleMagicBox = false;
    });
  }

  // Filter pictures to keep only Original, verify language and content
  filterPictures(pictures: ProgramArticlePictureETTValue[]) {
    return pictures.filter(
      (picture) =>
        (picture.pictureURL || picture.blob) &&
        picture.pictureFormatName == "Original" &&
        picture.language &&
        picture.language.id == this.currentUser.currentLanguage.id
    );
  }

  lockPictures(destination: Destination) {
    if (!this.disablePartnersField && !this.disablePressField) {
      if (
        this.programArticle.destinations.find((d) => d.id === destination.id)
          .value.pictures &&
        this.programArticle.destinations
          .find((d) => d.id === destination.id)
          .value.pictures.find((p) => p.pictureFormatName === "Original")
      ) {
        // Get Original Locked status and inverse it
        let newLockStatus = !this.programArticle.destinations
          .find((d) => d.id === destination.id)
          .value.pictures.find((p) => p.pictureFormatName === "Original")
          .isLocked;
        for (
          let i = 0;
          i <
          this.programArticle.destinations.find((d) => d.id === destination.id)
            .value.pictures.length;
          i++
        ) {
          this.programArticle.destinations.find(
            (d) => d.id === destination.id
          ).value.pictures[i].isLocked = newLockStatus;
          this.programArticle.destinations.find(
            (d) => d.id === destination.id
          ).value.pictures[i].modified = true;
        }
        this.programArticle.destinations.find(
          (d) => d.id === destination.id
        ).modified = true;
        this.programArticle.pictureModified = true;
      }
    }
  }

  duplicateDataPress(event) {
    if (event.checked) {
      this.duplicateData.emit();
      this.isProgramModifiedBeforeDuplicated = this.programModified;
      this.programModified = true;
      this.isDuplicateToPressOn = true;
      localStorage.setItem("isPressDuplicate", "true");
    } else {
      this.isDuplicateToPressOn = false;
      localStorage.setItem("isPressDuplicate", "false");
      localStorage.setItem("descriptionPressHasBeenReseted", "false");
      this.initialData.emit();
      this.programModified = this.isProgramModifiedBeforeDuplicated;
    }
  }

  duplicateDataPartners(event) {
    if (event.checked) {
      this.duplicateDigitalDataToPartners.emit();
      this.isProgramModifiedBeforeDuplicated = this.programModified;
      this.programModified = true;
      this.isDuplicateToPartnersOn = true;
      localStorage.setItem("isPartnersDuplicate", "true");
    } else {
      this.isDuplicateToPartnersOn = false;
      localStorage.setItem("isPartnersDuplicate", "false");
      localStorage.setItem("descriptionPartnersHasBeenReseted", "false");
      this.initialPartnersData.emit();
      this.programModified = this.isProgramModifiedBeforeDuplicated;
    }
  }

  duplicateDataInter(event) {
    if (event.checked) {
      this.duplicateInter.emit();
      this.isProgramModifiedBeforeDuplicated = this.programModified;
      this.programModified = true;
      this.programArticle.pictureModified = true;
      this.isDuplicateToInterOn = true;
    } else {
      this.deleteDataInter.emit();
      this.programModified = this.isProgramModifiedBeforeDuplicated;
      this.isDuplicateToInterOn = false;
    }
  }

  duplicateDataPressInter() {
    this.duplicatePressInter.emit();
  }

  clickOnSelectAllMultilingual() {
    if (this.multilingualLanguages.find((ml) => ml.id === -1)) {
      this.multilingualLanguages = this.multilingualLanguages.concat(
        this.availableLanguages
      );
    } else {
      this.multilingualLanguages = [];
      this.multilingualLanguages.push(this.currentUser.currentLanguage);
    }
  }

  // Method checking if we need to check on the Select all box
  clickOnSelectLanguageMultilingual() {
    if (
      this.multilingualLanguages.filter((ml) => ml.id != -1).length ===
      this.availableLanguages.length
    ) {
      this.multilingualLanguages.push(this.selectAllMultilanguage);
    } else {
      this.multilingualLanguages = this.multilingualLanguages.filter(
        (ml) => ml.id != -1
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/program-article-form/program-article-form.component.ts